var _g, _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconBalance(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 1676,
    height: 1024,
    viewBox: "0 0 1676 1024",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icomoon-ignore"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M238.727 703.454c0-25.706 20.839-46.545 46.545-46.545h1067.757c25.702 0 46.545 20.839 46.545 46.545v190.835c0 25.706-20.843 46.543-46.545 46.543h-1067.757c-25.706 0-46.545-20.837-46.545-46.543v-190.835zM331.818 750v97.745h974.666v-97.745h-974.666z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M788.258 207.505c17.465-15.088 43.348-15.099 60.826-0.027l534.341 460.802c14.736 12.703 20.015 33.229 13.238 51.463s-24.185 30.331-43.632 30.331h-1067.755c-19.446 0-36.842-12.088-43.623-30.312s-1.519-38.744 13.195-51.455l533.411-460.801zM818.712 304.213l-408.357 352.77h817.43l-409.073-352.77z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M1608.816 59.914c5.781 25.049-9.84 50.038-34.89 55.815l-1489.455 343.505c-25.049 5.777-50.038-9.846-55.815-34.894s9.846-50.038 34.895-55.815l1489.457-343.506c25.041-5.777 50.036 9.846 55.808 34.895z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconBalance);
export default __webpack_public_path__ + "static/media/icon-balance.950d30672dad28cce53fc450d79ecbaf.svg";
export { ForwardRef as ReactComponent };